import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import "./ImageCarousel.css";

function ImageCarousel() {
  const [index, setIndex] = useState(1);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="imagecorousel">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        prevIcon={
          <span aria-hidden="true" className="carousel-control-prev-icon" />
        }
        nextIcon={
          <span aria-hidden="true" className="carousel-control-next-icon" />
        }
      >
        <Carousel.Item>
          <img
            className="d-block w-100 home_image"
            src={require("./pics/i1.jpg")}
            alt="First slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 home_image"
            src={require("./pics/i2.jpg")}
            alt="second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 home_image"
            src={require("./pics/i3.png")}
            alt="Third slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 home_image"
            src={require("./pics/i4.jpg")}
            alt="fourth slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 home_image"
            src={require("./pics/i5.jpg")}
            alt="Fifth slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 home_image"
            src={require("./pics/i6.jpg")}
            alt="six slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 home_image"
            src={require("./pics/i7.jpg")}
            alt="seven slide"
          />
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default ImageCarousel;
